// test2008
(2008 && 0);
